import { Currency, CurrencySettings } from "@mcleod/core";
import { AutogenLayoutFinancials } from "./autogen/AutogenLayoutFinancials";
import { BlurEvent, DataSourceMode, Layout, LookupModelSearchEvent, SlideoutDecorator } from "@mcleod/components";
import { AutogenLayoutARInquiry } from "./autogen/AutogenLayoutARInquiry";
import { LMEGeneralSettings } from "@mcleod/general";

export class Financials extends AutogenLayoutFinancials {

    override async onLoad() {

        const currencySettings = CurrencySettings.getSingleton();
        const multicurrencyEnabled = currencySettings.multiCurrencyEnabled();
        this.textboxCurrencyType.visible = this.textboxCurrencyType.required = this.textboxCurrencyType.enabledDuringUpdate = multicurrencyEnabled;
        const enforceCredit = LMEGeneralSettings.getSingleton().getDispatchControl().enforce_credit;
        this.textboxCreditStatus.required = "S" === enforceCredit || "L" === enforceCredit;
    }

    textboxCurrencyTypeOnLookupModelSelection() {
        this.updateCurrencyFields();
    }

     updateCurrencyFields() {
            const currencySettings = CurrencySettings.getSingleton();
            if (currencySettings.multiCurrencyEnabled()) {
                if (this.mainDataSource.mode === DataSourceMode.ADD || this.mainDataSource.mode === DataSourceMode.UPDATE) {
                    const currencyType = this.mainDataSource.activeRow?.get("currency_type", currencySettings.getTransactionalCurrency());
                    const creditLimit = this.mainDataSource.activeRow?.getCurrency("credit_limit", null);
                    if (creditLimit != null) {
                        creditLimit.setCurrencyCode(currencyType);
                        this.mainDataSource.activeRow?.set("credit_limit", creditLimit);
                    }
                } else if (this.mainDataSource.mode === DataSourceMode.SEARCH) {
                    const currencyType = this.mainDataSource.searchRow?.get("currency_type", currencySettings.getFunctionalCurrency());
                    const creditLimit = this.mainDataSource.searchRow?.get("credit_limit") as Currency;
                    if (creditLimit != null && typeof creditLimit === "string") {
                        const amount = parseFloat(creditLimit);
                        if (isNaN(amount)) {
                            return;
                        }
                        const creditLimitCurrency = new Currency(amount);
                        creditLimitCurrency.setCurrencyCode(currencyType);
                        this.mainDataSource.searchRow?.set("credit_limit", creditLimitCurrency);
                    } else if (creditLimit instanceof Currency) {
                        creditLimit.setCurrencyCode(currencyType);
                        this.mainDataSource.searchRow?.set("credit_limit", creditLimit);
                    }
                }
            }
        }


    textboxInvoiceProcessingUserBeforeLookupModelSearch(event: LookupModelSearchEvent) {
            event.filter.web_user_type = "U";
    }

    unpostedOrdersOnClick() {
            const id = this.mainDataSource.activeRow?.get("id");
            if (id) {
                const layout = Layout.getLayout("lme/ar/ARInquiry") as AutogenLayoutARInquiry;
                new SlideoutDecorator({
                    layout: layout,
                    width: window.innerWidth * .75,
                    fillVerticalSpace: true,
                    title: "Customer Unposted Orders - " + this.mainDataSource.activeRow.get("name"),
                    layoutLoadListeners: () => layout.panelSearch.visible = false,
                    doAfterSlideIn: (decorator: SlideoutDecorator) => layout.mainDataSource.search({ "customer_id": id,  })
                });
            }
        }

    textboxCreditLimitOnBlur(event: BlurEvent) {
            if (event.changedWhileFocused) {
                this.updateCurrencyFields();
            }
    }

}